
// const servicesIcon
// const featuresListing = {
//   "Outlet Records": {icon:"bi bi-basket flex-shrink-0", graph: "Hotelace can be customised to accomodate the number of outlets in a given property, with accuarate postings and stockings."},
//   "Forecasting": {icon:"bi bi-binoculars flex-shrink-0", graph: "Hotelace eliminates the possibilities of over-booking and consequently, enhancing proper planning."},
//   "Stock Report": {icon:"bi bi-fullscreen-exit flex-shrink-0", graph: "The store module, a very important aspect of the application, is carefully designed and simulated to give reports on stocks, sales, requisitons etc, amongst other features, with proper controls in place."},
//   "Sales and Sales-summary": {icon:"bi bi-card-list flex-shrink-0", graph: "Hotelace collates sales-summary after each EOD, for the various outlets and consequently, the related stock-records, for each day,"},
//   "Requisitions & Issuance": {icon:"bi bi-broadcast flex-shrink-0", graph: "Hotelace records requisitions and issuances from the store, to the designated outlets; thereby, providing controls and assessment of stocks, in the store."},
//   "Invoices & Guests' bill": {icon:"bi bi-bullseye flex-shrink-0", graph: "Without the need for a second party application, Hotelace automatically collates guests' bills and invoices as requierd, for individual and group guests."},
//   "Expenditures & Purchases": {icon:"bi bi-gem flex-shrink-0", graph: "Hotelace provides a monthly report, by vendor and chart of accounts for all Expenditures and purchases. Hence, all expenses on maintenance, kitchen, stocks etc, are clearly accounted for."},
// }
export const servicesObjects = {
  "Software Engineering": {cls: "item-red", icon: "bi bi-broadcast", notes: "Our current day and age requires mechanisation of certain manual processes. At CrowFran, we possess the systems to mechanise these processes, by engineering them into algorithms, from speciffications, design and implementation."},
  "Solutions Architect": {cls: "item-cyan", icon: "bi bi-activity", notes: "At CrowFran, we understand business needs, owing to the concepts of optimization. Hence, we're open to partnering, developing and integrating; amongst others, to bring about the required optimizations, in line with businees needs."},
  "Machine Learning Models": {cls: "item-orange", icon: "bi bi-bounding-box-circles", notes: "Providing solutions that follows the path of being incrementally improved or developed, is one of our cores at CrowFran. Hence, we're making out steps, in the spheres of machine-learning and borders beyond."},
  "Solutions Consultancy": {cls: "item-teal", icon: "bi bi-easel", notes: "Consulting with us at CrowFran, is a means to provsioning ideas and concepts that are beyond the envisioned or anticipated needs of consultation."},
}

const Modules = () => {
    return(
      <section id="services" className="services section light-background">

      <div className="container section-title" data-aos="fade-up">
        <h2>Services</h2>
        <p>Necessitatibus eius consequatur ex aliquid fuga eum quidem sint consectetur velit</p>
      </div>

      <div className="container">

        <div className="row gy-4">

          <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="100">
            <div className="service-item  position-relative">
              <div className="icon">
                <i className="bi bi-activity"></i>
              </div>
              <a href="#" className="stretched-link">
                <h3>Nesciunt Mete</h3>
              </a>
              <p>Provident nihil minus qui consequatur non omnis maiores. Eos accusantium minus dolores iure perferendis tempore et consequatur.</p>
            </div>
          </div>

          <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="200">
            <div className="service-item position-relative">
              <div className="icon">
                <i className="bi bi-broadcast"></i>
              </div>
              <a href="#" className="stretched-link">
                <h3>Eosle Commodi</h3>
              </a>
              <p>Ut autem aut autem non a. Sint sint sit facilis nam iusto sint. Libero corrupti neque eum hic non ut nesciunt dolorem.</p>
            </div>
          </div>

          <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="300">
            <div className="service-item position-relative">
              <div className="icon">
                <i className="bi bi-easel"></i>
              </div>
              <a href="#" className="stretched-link">
                <h3>Ledo Markt</h3>
              </a>
              <p>Ut excepturi voluptatem nisi sed. Quidem fuga consequatur. Minus ea aut. Vel qui id voluptas adipisci eos earum corrupti.</p>
            </div>
          </div>

          <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="400">
            <div className="service-item position-relative">
              <div className="icon">
                <i className="bi bi-bounding-box-circles"></i>
              </div>
              <a href="#" className="stretched-link">
                <h3>Asperiores Commodit</h3>
              </a>
              <p>Non et temporibus minus omnis sed dolor esse consequatur. Cupiditate sed error ea fuga sit provident adipisci neque.</p>
              <a href="#" className="stretched-link"></a>
            </div>
          </div>

          <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="500">
            <div className="service-item position-relative">
              <div className="icon">
                <i className="bi bi-calendar4-week"></i>
              </div>
              <a href="#" className="stretched-link">
                <h3>Velit Doloremque</h3>
              </a>
              <p>Cumque et suscipit saepe. Est maiores autem enim facilis ut aut ipsam corporis aut. Sed animi at autem alias eius labore.</p>
              <a href="#" className="stretched-link"></a>
            </div>
          </div>

          <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="600">
            <div className="service-item position-relative">
              <div className="icon">
                <i className="bi bi-chat-square-text"></i>
              </div>
              <a href="#" className="stretched-link">
                <h3>Dolori Architecto</h3>
              </a>
              <p>Hic molestias ea quibusdam eos. Fugiat enim doloremque aut neque non et debitis iure. Corrupti recusandae ducimus enim.</p>
              <a href="#" className="stretched-link"></a>
            </div>
          </div>

        </div>

      </div>

    </section>

    )
}


export default Modules